import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiCalendar, FiUsers, FiClipboard, FiDollarSign, FiBriefcase, FiImage, FiMapPin, FiMessageCircle, FiMenu, FiX } from 'react-icons/fi';
import { WordpressLogo } from './WordpressLogo';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GB, ES } from 'country-flag-icons/react/3x2';
import axios from 'axios';

const Sidebar = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [groomName, setGroomName] = useState('');
  const [brideName, setBrideName] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const id = localStorage.getItem('id');
    if (id) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`)
        .then(response => {
          setGroomName(response.data.groom_name);
          setBrideName(response.data.bride_name);
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('token');
    // localStorage.removeItem('id');
    navigate('/login');
  };

  const links = [
    { to: '/', label: t('navigation.dashboard'), icon: <FiHome /> },
    { to: '/event-schedule', label: t('navigation.eventSchedule'), icon: <FiCalendar /> },
    { to: '/seating-chart', label: t('navigation.seatingChart'), icon: <FiUsers /> },
    { to: '/travel-accommodation', label: t('navigation.travelAccommodation'), icon: <FiMapPin /> },
    { to: '/budget', label: t('navigation.budget'), icon: <FiDollarSign /> },
    { to: '/planning', label: t('navigation.checklist'), icon: <FiClipboard /> },
    { to: '/vendors', label: t('navigation.vendors'), icon: <FiBriefcase /> },
  ];

  // Sidebar content
  const sidebarContent = (
    <div className="flex flex-col w-64 h-full bg-white border-r shadow-lg">
      <div className="h-20 flex items-center justify-between border-b mb-4 px-4">
        <div className="flex items-center">
          <WordpressLogo />
          <div className="flex gap-2 ml-4"> {/* Added ml-4 for spacing */}
            <button
              onClick={() => i18n.changeLanguage('en')}
              className={`p-1 rounded-full ${i18n.language === 'en' ? 'ring-2 ring-primary' : ''}`}
              aria-label="Switch to English"
            >
              <GB className="h-6 w-6 rounded-full" />
            </button>
            <button
              onClick={() => i18n.changeLanguage('es')}
              className={`p-1 rounded-full ${i18n.language === 'es' ? 'ring-2 ring-primary' : ''}`}
              aria-label="Switch to Spanish"
            >
              <ES className="h-6 w-6 rounded-full" />
            </button>
          </div>
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(false)} aria-label="Close sidebar">
          <FiX className="h-6 w-6" />
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto px-4 space-y-1">
        {links.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 rounded-lg transition-colors font-medium text-lg hover:bg-primary/10 ${isActive ? 'bg-primary/10 text-primary' : 'text-foreground'}`
            }
          >
            <span className="text-xl">{link.icon}</span>
            {link.label}
          </NavLink>
        ))}
      </nav>
      {/* User controls always at the bottom */}
      <div className="px-4 pb-4 border-t pt-4 mt-4">
        {localStorage.getItem('token') ? (
          <>
            <div
              className="flex items-center gap-2 mb-2 hover:bg-primary/10 rounded px-2 py-1 transition"
              tabIndex={0}
            >
              {groomName || brideName ? (
                <span className="bg-primary text-white h-8 w-8 flex items-center justify-center rounded-full font-bold">
                  {(groomName ? groomName[0].toUpperCase() : '') + (brideName ? brideName[0].toUpperCase() : '')}
                </span>
              ) : (
                <span className="bg-primary text-white h-8 w-8 flex items-center justify-center rounded-full font-bold">
                  ?
                </span>
              )}
              <span className="font-medium">
                {groomName && brideName ? `${groomName} & ${brideName}` : groomName || brideName || t('common.user')}
              </span>
            </div>
            <button onClick={handleLogout} className="w-full text-center mt-4 px-3 py-2 rounded bg-danger text-white hover:bg-red-600 transition-colors">{t('navigation.logout')}</button>
          </>
        ) : (
          <div className="flex flex-col gap-2">
            <button onClick={() => navigate('/login')} className="w-full text-left px-3 py-2 rounded hover:bg-primary/10">{t('login.loginButton')}</button>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {/* Hamburger for mobile */}
      <button
        className="fixed top-4 left-4 z-40 md:hidden bg-white p-2 rounded shadow"
        onClick={() => setOpen(true)}
        aria-label="Open sidebar"
      >
        <FiMenu className="h-6 w-6 text-primary" />
      </button>
      {/* Sidebar for desktop */}
      <aside className="hidden md:flex flex-col w-64 h-screen bg-white border-r shadow-lg fixed top-0 left-0 z-30">
        {sidebarContent}
      </aside>
      {/* Drawer sidebar for mobile */}
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black/30 z-40 md:hidden"
            onClick={() => setOpen(false)}
          />
          <aside className="fixed top-0 left-0 z-50 w-64 h-full bg-white shadow-lg animate-slide-in">
            {sidebarContent}
          </aside>
        </>
      )}
    </>
  );
};

export default Sidebar;
